// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileHeader_wrapper__IXQ-+","show":"MobileHeader_show__mUY3i"};